/**
 * Shared DOMPurify options for blog post body HTML.
 * Kept in sync for client (renderer) and server persistence.
 */
import type { Config } from 'dompurify';

/** Tags/attrs for full blog article body (rich editor output). */
export const BLOG_CONTENT_SANITIZE_CONFIG: Config = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'strong',
    'em',
    'u',
    'b',
    'i',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'li',
    'blockquote',
    'a',
    'img',
    'span',
    'div',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
    'mark',
    'del',
    'ins',
    'sub',
    'sup',
    'code',
    'pre',
    'kbd',
    'samp',
    'var',
    'cite',
    'abbr',
    'hr',
    'section',
    'article',
    'header',
    'footer',
  ],
  ALLOWED_ATTR: [
    'href',
    'target',
    'rel',
    'src',
    'alt',
    'title',
    'width',
    'height',
    'class',
    'id',
    'style',
    'colspan',
    'rowspan',
    'lang',
    'dir',
  ],
  ALLOW_DATA_ATTR: false,
  FORBID_ATTR: [
    'onclick',
    'onload',
    'onerror',
    'onmouseover',
    'onmouseout',
    'onmouseenter',
    'onmouseleave',
  ],
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
};
